<template>
  <div class="about-page">

    <div class="about-inner">

      <div class="header">
        <h1>Our Story</h1>
      </div>

      <div class="box ytoday">
        <h3>Today</h3>
        <div class="text">
          <img class="morenews" src="/static/newscomingsoon.jpg">
          <p>Today, we&rsquo;ve grown to 6 freelance site reps and 6 full time employees. The properties we represent now encompass over 150 buildings. </p>

          <p>I&rsquo;m most proud of the fact that everyone working at the Renees understands how important it is to keep the professionalism bar high and always protect - not only the property and its residents, but also the production staff.</p>

        </div>
        <div class="bottomtext">
           <p>We want production companies to know that when they work with our properties, we are there to make sure they get everything they need and take care of any problems that may arise. </p>

          <p>The Renees will always be there to make production as easy and drama-free as possible for both the property and the production team.</p>
        </div>
      </div>


      <div class="box y2021">
        <h3>2021</h3>
        <div class="vimeo">
          <iframe data-src="https://player.vimeo.com/video/954454208?autoplay=false&amp;muted=false&amp;loop=false&amp;byline=false&amp;portrait=false&amp;title=false" src="https://player.vimeo.com/video/954454208?autoplay=false&amp;muted=false&amp;loop=false&amp;byline=false&amp;portrait=false&amp;title=false" height="100%" width="100%" frameBorder="0" title="External Vimeo" aria-label="External Vimeo" data-testid="vimeo" allowfullscreen=""></iframe>
        </div>
      </div>

      <div class="box y2018">
        <h3>2018</h3>
        <div class="vimeo">
          <iframe data-src="https://player.vimeo.com/video/954457400?autoplay=false&amp;muted=false&amp;loop=false&amp;byline=false&amp;portrait=false&amp;title=false" src="https://player.vimeo.com/video/954457400?autoplay=false&amp;muted=false&amp;loop=false&amp;byline=false&amp;portrait=false&amp;title=false" height="100%" width="100%" frameBorder="0" title="External Vimeo" aria-label="External Vimeo" data-testid="vimeo" allowfullscreen=""></iframe>
        </div>
      </div>

      <div class="box y2011">
        <div class="text">
          <h3>2011</h3>
          <p>Since this was a one-woman operation, I did everything (the scouts, the shoots, the contracts) and as the business grew, I knew I would need help on bigger shoots. In 2011, I hired my first freelance site rep to help out on a movie shoot.</p>
        </div>
      </div>

      <div class="box y2009">
        <div class="text">
          <h3>2009 <small>(The Beginning)</small></h3>
          <p>Christopher Nolan&rsquo;s 2009 closure of Broadway while filming in DTLA actually inspired the birth of The Renees.</p>
          <p>At the time, I lived at Eastern Columbia. Because of my 25 years in television production, the General Manager asked me to help with negotiations and watch over the building.
The shoot was a success and it occurred to me&hellip;if I could do that for one building, why couldn&rsquo;t I do it for others? Many others.</p>
        </div>
      </div>

    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1740 2750.7"><path fill="#ffd44d" d="M218.3 0a9.6 9.6 0 0 0 .8 2.9c12.2 18.2 24.3 36.4 35.7 55.6L216.2 33l-33 24.2-.9-.5c1.2-2.2 2.3-4.3 3.6-6.4L214.3 6c1.1-1.8 1.6-4 2.3-6ZM1740 2444.2l-8.1 1.5c-4.1-5-10-24.7-10.4-35.3l9.3-3 3.7 11.3 5.5 16.8ZM1740 2472.3a74.1 74.1 0 0 0-3 7.5c-2 6.3-3.6 12.7-5.6 20l-11-2.6c3.1-12.3 5.6-23.7 9.8-35.1l9.8 1.4ZM609.4 1654h-80v-28.2h80ZM162.3 2311a32.8 32.8 0 0 1 2.4-5.5q16.2-24.5 32.6-48.8a40.4 40.4 0 0 1 2.7-3.2l35.3 54.8-.9 1.1-33.3-24.2-38.8 25.9ZM1459.6 706.6a32.5 32.5 0 0 1 2.4-5.5l32.5-48.8a36.9 36.9 0 0 1 2.8-3.1l35.3 54.8-.9 1.1-33.3-24.3-38.9 25.9ZM162.3 1422c.8-1.9 1.3-3.9 2.4-5.5q16.1-24.4 32.5-48.7c.6-1 1.4-1.7 2.7-3.3l35 54.3-1 1.2-32.8-23.8-38.9 25.9ZM1512.4 2549.9l-24.8 33.7 25.2 38-1 1-56.2-37.4 55.9-36ZM774 2333.7l57.6 37.9-55.3 35.6-1-1 23.8-32.8-4.8-8q-10-15.9-20.2-31.6ZM1218.5 1095l-1.6-11.6c12.8-2.6 24.8-.8 36.3-1.4 3.7 5 3.2 8.9-.5 13ZM1165 1083.9c6.6-2.1 26.5-2.6 36.2-1 3.3 4.3 2.7 8.3-1.4 12.3h-32c-4.4-2.9-3.2-7-2.9-11.3Z"/><path fill="#ffd44d" d="M1502.5 705.7v34.7c-5.1 2-9 1.7-12-3v-33.8c4.9-1.9 8.9-2.3 12 2.1ZM1491 914c4.6-1.8 8.4-2.2 11.5 2v35c-4.8 1.6-8.6 1.5-11.5-2.8ZM1490.6 756c5.4-1.7 9.2-1.8 11.9 2.3V793c-4.7 1.7-8.5 1.7-11.9-3ZM1490.7 808.6c5.4-1.7 9.2-1.9 11.8 2.4v34.6c-7.2 1.4-7.2 1.4-11.8-3ZM1490.8 895.3v-34c4.7-1.7 8.5-2.1 11.6 2v35.2c-7.3 1-7.3 1-11.6-3.2ZM1270.8 1082.7h35.9v12c-11.8.3-22.7.4-33.3.3-4.9-3.1-3.9-7.1-2.6-12.3ZM211.4 55h10.3c2 6.5 2.3 26.7.5 36.4h-10.8ZM221.8 107.6c2 6.6 2.2 27.4.3 36.4h-10.7v-36.4ZM1004 2376.3v-11.2c12-.4 23.3-.1 36-.1l.7 11.3c-12.8.3-24.5.3-36.8 0ZM1109.2 2375.7v-10.3h36v10.3ZM1198.7 2375.7h-37l-.5-9c6.4-2.3 26.2-2.8 36.7-.9l.8 9.9ZM1356 2366v8.5a105 105 0 0 1-36.6.6l-.4-8.4c6.7-2.3 26.6-2.7 37-.7ZM1372 2375.6v-10.2h36.2l.6 10.2ZM690.4 2378.5c-3.6-5.1-3.6-5.1-2.5-11 6-2.3 26-2.7 35-.8 2.2 6 2.2 6-1.7 11.8ZM194 2307.3h9.5a98 98 0 0 1 .5 36.1h-10ZM584.7 2378.8c-3.2-4-4.2-7.7-1.3-12.4h34c2.4 6.2 2.4 6.2-1.3 12.3ZM205.3 2396h-11.6c-.2-12.3-.3-23.7 0-35.8h11c1.4 12 .7 23.6.6 35.8ZM335.4 1986.6h9.6c1.3 12.1.7 23.8.5 36.1h-10c-2.2-7-2.3-28.4-.1-36ZM668.5 2378.8h-30.9c-3.5-3.7-4.5-7.4-1.6-12.5h34.2c3 4.7 2.2 8.5-1.7 12.5ZM345.2 1970.1h-9.8c-2.2-7.1-2.2-28.4 0-36.2h9.9c.3 12.2.6 23.9 0 36.2ZM532 2378.9c-3-4.1-4.1-7.8-1.6-11.7 6.9-1.8 26.9-2 34.6-.3 2.2 5.9 2.2 5.9-1.5 12ZM205 1770.3l-8.4.4c-2.6-6.5-3-26.7-.9-36.7l8.4-.4c2.6 6.5 3 26.5.9 36.7ZM510.8 2379h-31.2c-3.3-3.4-4-7.1-2.3-11.2a91.7 91.7 0 0 1 35.6-.6c2.4 4.2 1.4 8-2.1 11.8ZM205.7 1786.8v36.1l-9 .4c-2.6-6.5-3-26.7-1-36.5ZM1056.6 2375.8V2365c11.9-.2 23.4-.2 35.8 0v10.8ZM205.4 2448.8h-10c-2.3-7.3-2.5-28-.3-36h9.8c1.1 12 .5 23.6.5 36ZM344 2075.4h-8a89.2 89.2 0 0 1-1-36l8.1-1c1 1.5 2.2 2.6 2.4 3.8 1.1 6 .1 28.2-1.5 33.2ZM195.4 2033.1v-35.7H206v35.7ZM1266.8 2376.3v-9.6a98.4 98.4 0 0 1 36-.5v10c-11.8.4-23.3.2-36 0ZM355.6 2283l-10.3 3.2c-5.2-11.2-6.6-23-10.5-34.8l9.3-4.1c6.5 11 7.3 23.2 11.5 35.8ZM20.8 443.9l-10.5 3c-4.9-11.4-6.7-23-10.3-35.2l10.3-3.7c4.7 11.8 6.8 23.4 10.4 35.9ZM204.9 211.6l-18.2 31.7-10.2-5.7 18.3-31.7ZM214.3 2656.9l-9.3 2.8c-5-11.3-6.6-23-10.5-35l9-3.4c4.3 5.5 9.4 22.5 10.8 35.6ZM127.6 267l3.4 9c-11.7 6-23.8 7.5-36.1 10.9L92 278c5-4.4 22.3-9.7 35.6-11ZM196.1 1718c-2-6.9-2.5-25.9-.8-36.4l10.1-.5v36.4ZM344.1 1764.2l-9.5-2.4c2.1-12.2 5.7-23.4 9.1-35.5l9.3 1.7c.6 7.1-4 26-8.9 36.2ZM1492.7 1002.4l-10.8-2.7c2.7-12.4 5.5-23.7 9.9-35.7l10.1 2.7c-2.3 12.4-5.7 23.6-9.2 35.7ZM11.7 357l10.8 3.5-9.3 35-10.8-2c2-12.7 5.8-24 9.3-36.5ZM1600 2326c-11.8 5.2-23.6 7-35.7 10.5l-3.2-10c11.5-5.1 23.3-6.9 35.5-10.5l3.5 10ZM222 161.3l-9.5 35.3-11.2-2.3 9.3-35.4ZM415.6 1661.4l-31.8 18.4-6-8.8c10-7.8 20.7-13.2 32-19ZM240 2700.3l-9.6 5.8c-7-10.5-12.4-21-18.8-31.9l9.4-5.4c7.3 10 12.4 20.4 19 31.5ZM45.4 487.5l-9.6 5.8c-7-10.5-12.4-20.9-18.8-31.9l9.4-5.4c7.4 10 12.4 20.4 19 31.5ZM1705.2 2360.8l18.6 32-7.8 5.2c-5.4-4-14.3-18.1-19.6-31.1ZM1695.6 2540.8c6.5-11.3 11.9-21.5 18.3-31a29.1 29.1 0 0 1 4.3 1.3c1.5.8 2.9 1.8 4.1 2.7a91 91 0 0 1-18.3 32.1ZM370.5 2333.1l-18.6-32.2 8.2-5c1.5.8 2.5 1 3 1.7l17 28.7ZM1421 1066.9l31.5-18.4 6.3 9.1c-10.4 7.5-21 12.6-31.9 19ZM1214.4 2375.5v-10.2h36.3v10.2ZM50.8 310.8l-5.1-9.5 31.5-18 5 7.3c-3.5 5.6-14.4 12.6-31.4 20.2ZM1412.8 1083.9c-12.8 3.6-24 7.3-36.5 9.2l-2.4-10.4 35.1-9.5 3.8 10.7ZM1461.8 2365.2l-.6 10.3h-36.4l-.5-10.7c12.8 0 24.6-.7 37.5.4ZM91.2 527.3l2.7-10.4c12.4 1.7 23.5 5.7 36 8.9l-3 11ZM463 1645.5l-35.8 9.7-3-11c12.3-3.4 23.4-7.1 35.8-9l3 10.3ZM1612 2579a320 320 0 0 1 34.7-9.1l3 9.7c-11.1 5-22.7 6.5-33.3 10-4.6-2.3-5-5.8-4.4-10.5ZM286 2739.6l2.7-9.9c12.5 1.8 23.6 5.8 36 8.8l-3.1 11c-12.3-3-23.6-5.7-35.6-9.9ZM461.3 2376.1l-35.2-9.6 2.8-10.3c12.5 2 23.7 5.6 36 9.1l-3.6 10.8ZM1610.6 2328.7l3.7-11 35 9.5-2.1 10.5c-12.5-1.7-23.6-5.8-36.6-9ZM1475.5 2374.8l-2.8-10.6 33.3-9.2c4.6 2.3 5 5.7 4.4 10.5a337 337 0 0 1-34.9 9.3ZM741 2376.9v-11h36.3l.4 10.4c-12.5 1.1-24.2.5-36.7.6ZM1323.4 1094.6v-11.4c12-.8 23.5-.6 36-.3v11.1c-12 .6-23.6 0-36 .6ZM204.6 2202.3v36h-9.3c-2-6.4-2.3-28.2-.5-36ZM1460.5 1040.8l17.3-30 10 5.9-16.8 29.2ZM1523 2357.6l-5.7-10 29.8-17.2 5.9 9.4c-9.5 6.7-19.3 11.5-30 17.8ZM1687.8 2359a344.7 344.7 0 0 1-29.8-17.3l5.6-9.6 29.9 17.1ZM33.7 313.1l9.8 6.3L26.2 349l-9.9-5.7ZM194 2570.5h11.3c.5 12.2.6 23.8.1 36.1h-11.2a925 925 0 0 1-.2-36.1ZM195.9 2517.9h8.1c2.2 7.2 2.3 28.4.1 36.2h-8.6a87 87 0 0 1 .4-36.2ZM345.7 2233.1h-9.9c-2-6.4-2.3-27.6-.3-36h9.9c1 12 .6 23.6.3 36ZM204 2501.4h-8.6c-2-7.2-2.1-28.3 0-36h8.5c2.2 7 2.3 28.1.1 36ZM335.4 2144.3h9.7c1.4 12 .8 23.7.4 36.3l-9.5.5c-2.3-6.7-2.6-27.4-.6-36.8ZM195.6 1523.5h9c2.4 6 1 11.8 1.2 17.5s0 11.5 0 18.4l-9.7.8a95.7 95.7 0 0 1-.5-36.7ZM345.2 2091.3v36.7l-9.2.5c-2.3-6.9-2.6-27.4-.6-36.8ZM205.2 2048.7v34.5h-10.7v-35.1c4-2.4 7.3-2.4 10.7.6ZM206 1612.3h-10a97.2 97.2 0 0 1-.4-36h9c2.5 5.8 1 11.7 1.3 17.3s0 11.5 0 18.7ZM206 1665h-11.3c-.8-12-.4-23.4-.5-36l11.5-.7c.5 12.5.2 24 .3 36.7ZM477.2 1634.5h35.9v10.5h-35.9ZM333.1 1813v-35.7l9.4-1c2.3 7.3 2.5 28.3.5 36.7ZM334.8 1829.3h10.3c.4 11.6.4 23 0 35.4l-9.2.8c-2.3-6.4-2.8-27.7-1-36.2ZM337 2750.7v-11.1c12.2-.4 23.6-.4 36 0v11ZM195 1471h9.2c2 6.4 2.3 24.5.7 36l-9 .6c-2.2-7-2.6-24.8-.9-36.7ZM247 536.2l.6-9.6h36.2l.5 9.1a96 96 0 0 1-37.3.5ZM195 537.7v-11h36v10.8c-12 .6-23.4.3-36 .2ZM1688.1 2549.2l5.4 8.8c-9.7 6.6-19.3 11.6-29.7 17.4l-5.2-7.9a89.5 89.5 0 0 1 29.5-18.3ZM142.4 537.2v-10.4h36v10.4ZM1510 2579.8h35.6c.3 3.3.7 6.4 1 10.8-12.7 1-24.4.3-36.7.4ZM1562.3 2591v-11.4c12.1-.6 23.6-.1 36-.2l.8 11.5c-12.6.5-24 .1-36.8.1ZM77 522.4l-29.4-17.1 5.5-10 30 17.1ZM417.9 2351.8l-4.6 8.3a83 83 0 0 1-30.4-16.7l4.7-8.5c10.6 4.9 19.7 10.9 30.3 17ZM241.8 2717.6l6-9.5 29.6 17-4.9 9.7c-10.8-5-20.2-10.6-30.7-17.2ZM196 1839.2h8.8c2.5 6 1 11.9 1.3 17.6s0 11.6 0 18.5l-9.9.6c-2-7.9-2.2-27.7-.2-36.7ZM344.3 1917.6h-8.6a103 103 0 0 1-.6-36.2h8.7c2 6.7 2.4 26.2.5 36.2ZM194.8 1892h10.8v36h-10.5c-.7-12-.5-23.8-.3-36ZM205.6 1944.6v36.1l-8.8.5a96 96 0 0 1-.6-36.6ZM204.3 2096.5v36.6h-10.1V2097ZM898.7 2375.2v-9.4h36.1l.4 8.9c-7.1 2.4-28 2.6-36.5.5ZM951.4 2376v-10.3h36l.7 9.7c-12.5 2.1-24.4 1.2-36.7.6ZM193.6 2149.5h9.5a97 97 0 0 1 .6 36.1H194c-.5-11.9-.3-23.4-.3-36.1ZM882.1 2366.5v10c-12 .4-23.5.4-36 .1l-.6-9.5c7-2.3 27.7-2.5 36.6-.6ZM144.9 272.3l-6-9c9.5-7 19.4-12 29.9-17.8l5.6 9.5c-9.8 6.4-19.3 11.6-29.5 17.3ZM366 1682l8.1 4.8a83.7 83.7 0 0 1-17 30l-8.3-5A497.5 497.5 0 0 1 366 1682ZM195.3 1420.7h8.7c2.3 6.5 2.6 24.4.5 34l-8.4.4a85.8 85.8 0 0 1-.8-34.4ZM162.3 1422.1l-.3.2.3-.3v.1zM1459.5 706.7l-.2.2.3-.2h-.1zM162.3 2311.1l-.3.1.3-.2v.1zM774.2 2333.8l-.3-.2.2.1.1.1z"/></g></svg>
    </div><!-- /about-inner -->
  </div><!-- /.about-page -->
</template>

<script>
export default {
  name: 'AboutPage',
  data () {
    return {
    }
  },
  created () {
    document.title = 'Our Story - The Renees'
    document.head.querySelector('meta[name=description]').content = 'The Renees started in 2009 to help manage the complexities of filming in apartment buildings. Everyone working at the Renees understands how important it is to keep the professionalism bar high and always protect - not only the property and its residents, but also the production staff.'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/_mixins.scss";

.about-page {
  background: #a562a5;
  padding: 2em 1em 1em;
  @include bp(most) {
    padding: 6em 1.5em 3em;
  }
}
.about-inner {
  @include bp(most) {
    max-width: 1020px;
    margin: 0px auto;
    position: relative;
    height: 2550px;
    transform-origin: top;
  }
  @include bp(small) {
    transform: scale(.65);
    height: 1465px;
  }
  @include bp(medium) {
    transform: scale(.8);
    height: 1817px;
  }
}


.header {
  background: #895189;
  padding: 1em;
  @include bp(most) {
    height: 140px;
    width: 900px;
    position: relative;
    padding: 0;
  }
  h1 {
    color: #FFF;
    letter-spacing: -.1em;
    font-weight: 700;
    margin: 0px;
    font-family: "Lulo", Helvetica, Arial, sans-serif;
    text-align: center;
    border-bottom: 5px solid #f4ca36;
    font-size: 36px;
    line-height: 50px;
    @include bp(most) {
      line-height: 82px;
      font-size: 80px;
      position: absolute;
      right: -110px;
      padding-right: 151px;
      padding-left: 61px;
      top: 29px;
    }
  }
}

.box {
  box-sizing: border-box;
  z-index: 1;
  color: #f4ca36;
  @include bp(most) {
    position: absolute;
  }
  h3 {
    font-family: $lulo;
    font-weight: 200;
    margin: 0;
    padding: 0;
    line-height: 26px;
    font-size: 24px;
    @include bp(most) {
      line-height: 48px;
      font-size: 46px;
    }
    small {
      font-size: 32px;
      display: inline-block;
      @include bp(most) {
        margin-left: -12px;
      }
    }
  }
}

.vimeo {
  background: #444;
}

.y2018 {
  background: #b47cb4;
  @include bp(most) {
    width: 616px;
    height: 341px;
    top: 1222px;
    left: 81px;
  }
  h3 {
    @include bp(most) {
      position: absolute;
      right: 20px;
      top: 127px;
    }
  }
  .vimeo {
    @include bp(most) {
      position: absolute;
      left: -91px;
      top: 5px;
      width: 520px;
      height: 301px;
    }
  }
}

.y2021 {
  background: #a051a0;
  @include bp(most) {
    width: 607px;
    height: 313px;
    top: 849px;
    left: 158px;
    h3 {
      position: absolute;
      left: 33px;
      top: 181px;
    }
    .vimeo {
      position: absolute;
      right: -138px;
      top: -42px;
      width: 520px;
      height: 301px;
    }
  }
}

.y2009 {
  background: #895189;
  @include bp(most) {
    width: 718px;
    height: 392px;
    top: 1622px;
    left: 289px;
    .text {
      position: absolute;
      width: 698px;
      height: 367px;
      box-sizing: border-box;
      text-align: left;
      padding: 18px 52px 0px 42px;
      border: 2px solid #f4ca36;
      left: 36px;
      top: 42px;
      p {
        font-family: $futura;
        font-size: 20px;
        text-align: justify;
        line-height: 1.4;
      }
    }
  }
}

.y2011 {
  background: #b47cb4;
  @include bp(most) {
    width: 744px;
    height: 331px;
    top: 2212px;
    left: 117px;
    .text {
      position: absolute;
      width: 594px;
      box-sizing: border-box;
      text-align: left;
      right: 14px;
      top: 29px;
      h3 {
        text-align: right;
      }
      p {
        text-align: left;
        font-family: $futura;
        font-size: 20px;
        line-height: 1.6;
        text-align: justify;
        padding-right: 20px;
        margin-top: 22px;
      }
    }
  }
}

.ytoday {
  @include bp(most) {
    width: 1000px;
    height: 460px;
    top: 190px;
    left: 4px;
    h3 {
      background: #a051a0;
      width: 599px;
      height: 179px;
      box-sizing: border-box;
      padding: 25px 0 0 57px;
      z-index: 1;
    }
  }
  p {
    text-align: left;
    font-family: $futura;
    font-size: 20px;
    line-height: 1.4;
    text-align: justify;
    margin-top: 22px;
  }
  .morenews {
    max-width: 100%;
    margin-top: .5em;
    @include bp(most) {
      margin: 0;
      float: right;
      width: 500px;
      height: 281px;
      margin-top: -46px;
      margin-right: -104px;
      padding-left: 28px;
    }
  }
  .text {
    background: #895189;
    @include bp(most) {
      z-index: 2;
      padding: 8px 73px 0 24px;
      position: absolute;
      width: 851px;
      height: 311px;
      box-sizing: border-box;
      text-align: left;
      left: 21px;
      top: 63px;
    }
  }
  .bottomtext {
    background: #b47cb4;
    @include bp(most) {
      position: absolute;
      width: 952px;
      height: 230px;
      box-sizing: border-box;
      text-align: left;
      left: -30px;
      top: 332px;
      z-index: 1;
      padding: 31px 96px 0 73px;
    }
  }
}

svg {
  width: 1020px;
  height: 1720px;
  position: absolute;
  left: 0px;
  top: 688px;
  z-index: 5;
  pointer-events: none;
  display: none;
  @include bp(most) {
    display: block;
  }
}

@include bp(mobile) {
  .box {
   margin-top: 2em;
   padding: 1em;
   .text {
     padding: .5em 1em;
     p {
       font-size: 14px;
     }
   }
   h3 {
     font-weight: 600;
     font-size: 32px;
     margin-bottom: -5px;
     small {
       font-size: 18px;
     }
   }
   .vimeo {
    height: 189px
   }
   .bottomtext {
     margin-top: 0px;
     padding: .5em 1em;
     p {
      font-size: 14px;
     }
   }
  }
}

</style>



// WEBPACK FOOTER //
// AboutPage.vue?02255f1c